import { createRouter, createWebHashHistory } from 'vue-router'
import { useStore } from 'vuex';

import AdminMainPage from '../components/views/Admin/MainPage.vue'
import AdminAdminsEdit from '../components/views/Admin/AdminsEdit.vue'
import AdminAdminsList from '../components/views/Admin/AdminsList.vue'
import AdminRolesEdit from '../components/views/Admin/RolesEdit.vue'
import AdminRolesList from '../components/views/Admin/RolesList.vue'

import AdminAdminLogsEdit from '../components/views/Admin/AdminLogsEdit.vue'
import AdminAdminLogsList from '../components/views/Admin/AdminLogsList.vue'
import AdminCategorysEdit from '../components/views/Admin/CategorysEdit.vue'
import AdminCategorysList from '../components/views/Admin/CategorysList.vue'
import AdminCoinLogsEdit from '../components/views/Admin/CoinLogsEdit.vue'
import AdminCoinLogsList from '../components/views/Admin/CoinLogsList.vue'
import AdminDriftBottleLogsList from '../components/views/Admin/DriftBottleLogsList.vue'
import AdminDriftBottlesEdit from '../components/views/Admin/DriftBottlesEdit.vue'
import AdminDriftBottlesList from '../components/views/Admin/DriftBottlesList.vue'
import AdminDriftBottleTypesEdit from '../components/views/Admin/DriftBottleTypesEdit.vue'
import AdminDriftBottleTypesList from '../components/views/Admin/DriftBottleTypesList.vue'
import AdminFollowsEdit from '../components/views/Admin/FollowsEdit.vue'
import AdminFollowsList from '../components/views/Admin/FollowsList.vue'
import AdminInterestsEdit from '../components/views/Admin/InterestsEdit.vue'
import AdminInterestsList from '../components/views/Admin/InterestsList.vue'
import AdminMailCommentsEdit from '../components/views/Admin/MailCommentsEdit.vue'
import AdminMailCommentsList from '../components/views/Admin/MailCommentsList.vue'
import AdminMailsEdit from '../components/views/Admin/MailsEdit.vue'
import AdminMailsList from '../components/views/Admin/MailsList.vue'
import AdminMeiliLogsEdit from '../components/views/Admin/MeiliLogsEdit.vue'
import AdminMeiliLogsList from '../components/views/Admin/MeiliLogsList.vue'
import AdminOfferRewardsEdit from '../components/views/Admin/OfferRewardsEdit.vue'
import AdminOfferRewardsList from '../components/views/Admin/OfferRewardsList.vue'
import AdminRechargeLogsEdit from '../components/views/Admin/RechargeLogsEdit.vue'
import AdminRechargeLogsList from '../components/views/Admin/RechargeLogsList.vue'
import AdminRechargePricesEdit from '../components/views/Admin/RechargePricesEdit.vue'
import AdminRechargePricesList from '../components/views/Admin/RechargePricesList.vue'
import AdminSchoolsEdit from '../components/views/Admin/SchoolsEdit.vue'
import AdminSchoolsList from '../components/views/Admin/SchoolsList.vue'
import AdminSignsEdit from '../components/views/Admin/SignsEdit.vue'
import AdminSignsList from '../components/views/Admin/SignsList.vue'
import AdminSiteConfigEdit from '../components/views/Admin/SiteConfigEdit.vue'
import AdminUsersEdit from '../components/views/Admin/UsersEdit.vue'
import AdminUsersList from '../components/views/Admin/UsersList.vue'
import AdminVipLevelsEdit from '../components/views/Admin/VipLevelsEdit.vue'
import AdminVipLevelsList from '../components/views/Admin/VipLevelsList.vue'
import AdminVipLogsEdit from '../components/views/Admin/VipLogsEdit.vue'
import AdminVipLogsList from '../components/views/Admin/VipLogsList.vue'
import AdminVipPricesEdit from '../components/views/Admin/VipPricesEdit.vue'
import AdminVipPricesList from '../components/views/Admin/VipPricesList.vue'
import AdminVipRechargeLogsEdit from '../components/views/Admin/VipRechargeLogsEdit.vue'
import AdminVipRechargeLogsList from '../components/views/Admin/VipRechargeLogsList.vue'

import AdminChatDetailsList from '../components/views/Admin/ChatDetailsList.vue'
import AdminChatsList from '../components/views/Admin/ChatsList.vue'
import AdminCircleEvaluatesList from '../components/views/Admin/CircleEvaluatesList.vue'
import AdminCirclesList from '../components/views/Admin/CirclesList.vue'
import AdminNoticesList from '../components/views/Admin/NoticesList.vue'
import AdminToususEdit from '../components/views/Admin/ToususEdit.vue'
import AdminToususList from '../components/views/Admin/ToususList.vue'

import AdminRewardLogsList from '../components/views/Admin/RewardLogsList.vue'
import AdminWithdrawLogsEdit from '../components/views/Admin/WithdrawLogsEdit.vue'
import AdminWithdrawLogsList from '../components/views/Admin/WithdrawLogsList.vue'


import Login from '../components/login/Log.vue'
import Index from '../components/views/index.vue'

const Router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: Index,
      name: 'Index',
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: { requiresAuth: false }
    },
    {
      path: '/admin',
      component: AdminMainPage,
      name: 'AdminMainPage',
      meta: { requiresAuth: true },
      children: [
				{
					path: '/admin/AdminLogsEdit',
					component: AdminAdminLogsEdit,
					name: 'AdminLogsEdit'
				},

				{
					path: '/admin/AdminLogsList',
					component: AdminAdminLogsList,
					name: 'AdminLogsList'
				},

				{
					path: '/admin/AdminsEdit',
					component: AdminAdminsEdit,
					name: 'AdminsEdit'
				},

				{
					path: '/admin/AdminsList',
					component: AdminAdminsList,
					name: 'AdminsList'
				},

				{
					path: '/admin/CategorysEdit',
					component: AdminCategorysEdit,
					name: 'CategorysEdit'
				},

				{
					path: '/admin/CategorysList',
					component: AdminCategorysList,
					name: 'CategorysList'
				},

				{
					path: '/admin/CoinLogsEdit',
					component: AdminCoinLogsEdit,
					name: 'CoinLogsEdit'
				},

				{
					path: '/admin/CoinLogsList',
					component: AdminCoinLogsList,
					name: 'CoinLogsList'
				},
				
				{
					path: '/admin/DriftBottleLogsList',
					component: AdminDriftBottleLogsList,
					name: 'DriftBottleLogsList'
				},

				{
					path: '/admin/DriftBottleTypesEdit',
					component: AdminDriftBottleTypesEdit,
					name: 'DriftBottleTypesEdit'
				},

				{
					path: '/admin/DriftBottleTypesList',
					component: AdminDriftBottleTypesList,
					name: 'DriftBottleTypesList'
				},

				{
					path: '/admin/DriftBottlesEdit',
					component: AdminDriftBottlesEdit,
					name: 'DriftBottlesEdit'
				},

				{
					path: '/admin/DriftBottlesList',
					component: AdminDriftBottlesList,
					name: 'DriftBottlesList'
				},

				{
					path: '/admin/FollowsEdit',
					component: AdminFollowsEdit,
					name: 'FollowsEdit'
				},

				{
					path: '/admin/FollowsList',
					component: AdminFollowsList,
					name: 'FollowsList'
				},

				{
					path: '/admin/InterestsEdit',
					component: AdminInterestsEdit,
					name: 'InterestsEdit'
				},

				{
					path: '/admin/InterestsList',
					component: AdminInterestsList,
					name: 'InterestsList'
				},

				{
					path: '/admin/MailCommentsEdit',
					component: AdminMailCommentsEdit,
					name: 'MailCommentsEdit'
				},

				{
					path: '/admin/MailCommentsList',
					component: AdminMailCommentsList,
					name: 'MailCommentsList'
				},

				{
					path: '/admin/MailsEdit',
					component: AdminMailsEdit,
					name: 'MailsEdit'
				},

				{
					path: '/admin/MailsList',
					component: AdminMailsList,
					name: 'MailsList'
				},

				{
					path: '/admin/MeiliLogsEdit',
					component: AdminMeiliLogsEdit,
					name: 'MeiliLogsEdit'
				},

				{
					path: '/admin/MeiliLogsList',
					component: AdminMeiliLogsList,
					name: 'MeiliLogsList'
				},

				{
					path: '/admin/OfferRewardsEdit',
					component: AdminOfferRewardsEdit,
					name: 'OfferRewardsEdit'
				},

				{
					path: '/admin/OfferRewardsList',
					component: AdminOfferRewardsList,
					name: 'OfferRewardsList'
				},

				{
					path: '/admin/RechargeLogsEdit',
					component: AdminRechargeLogsEdit,
					name: 'RechargeLogsEdit'
				},

				{
					path: '/admin/RechargeLogsList',
					component: AdminRechargeLogsList,
					name: 'RechargeLogsList'
				},

				{
					path: '/admin/RechargePricesEdit',
					component: AdminRechargePricesEdit,
					name: 'RechargePricesEdit'
				},

				{
					path: '/admin/RechargePricesList',
					component: AdminRechargePricesList,
					name: 'RechargePricesList'
				},

				{
					path: '/admin/RolesEdit',
					component: AdminRolesEdit,
					name: 'RolesEdit'
				},

				{
					path: '/admin/RolesList',
					component: AdminRolesList,
					name: 'RolesList'
				},

				{
					path: '/admin/SchoolsEdit',
					component: AdminSchoolsEdit,
					name: 'SchoolsEdit'
				},

				{
					path: '/admin/SchoolsList',
					component: AdminSchoolsList,
					name: 'SchoolsList'
				},

				{
					path: '/admin/SignsEdit',
					component: AdminSignsEdit,
					name: 'SignsEdit'
				},

				{
					path: '/admin/SignsList',
					component: AdminSignsList,
					name: 'SignsList'
				},

				{
					path: '/admin/SiteConfigEdit',
					component: AdminSiteConfigEdit,
					name: 'SiteConfigEdit'
				},

				{
					path: '/admin/UsersEdit',
					component: AdminUsersEdit,
					name: 'UsersEdit'
				},

				{
					path: '/admin/UsersList',
					component: AdminUsersList,
					name: 'UsersList'
				},

				{
					path: '/admin/VipLevelsEdit',
					component: AdminVipLevelsEdit,
					name: 'VipLevelsEdit'
				},

				{
					path: '/admin/VipLevelsList',
					component: AdminVipLevelsList,
					name: 'VipLevelsList'
				},

				{
					path: '/admin/VipLogsEdit',
					component: AdminVipLogsEdit,
					name: 'VipLogsEdit'
				},

				{
					path: '/admin/VipLogsList',
					component: AdminVipLogsList,
					name: 'VipLogsList'
				},

				{
					path: '/admin/VipPricesEdit',
					component: AdminVipPricesEdit,
					name: 'VipPricesEdit'
				},

				{
					path: '/admin/VipPricesList',
					component: AdminVipPricesList,
					name: 'VipPricesList'
				},

				{
					path: '/admin/VipRechargeLogsEdit',
					component: AdminVipRechargeLogsEdit,
					name: 'VipRechargeLogsEdit'
				},

				{
					path: '/admin/VipRechargeLogsList',
					component: AdminVipRechargeLogsList,
					name: 'VipRechargeLogsList'
				},

				
				{
					path: '/admin/ChatDetailsList',
					component: AdminChatDetailsList,
					name: 'ChatDetailsList'
				},

				{
					path: '/admin/ChatsList',
					component: AdminChatsList,
					name: 'ChatsList'
				},

				{
					path: '/admin/CircleEvaluatesList',
					component: AdminCircleEvaluatesList,
					name: 'CircleEvaluatesList'
				},

				{
					path: '/admin/CirclesList',
					component: AdminCirclesList,
					name: 'CirclesList'
				},

				{
					path: '/admin/NoticesList',
					component: AdminNoticesList,
					name: 'NoticesList'
				},

				{
					path: '/admin/ToususEdit',
					component: AdminToususEdit,
					name: 'ToususEdit'
				},

				{
					path: '/admin/ToususList',
					component: AdminToususList,
					name: 'ToususList'
				},

				{
					path: '/admin/WithdrawLogsEdit',
					component: AdminWithdrawLogsEdit,
					name: 'WithdrawLogsEdit'
				},

				{
					path: '/admin/WithdrawLogsList',
					component: AdminWithdrawLogsList,
					name: 'WithdrawLogsList'
				},

				{
					path: '/admin/RewardLogsList',
					component: AdminRewardLogsList,
					name: 'AdminRewardLogsList'
				},
      ]
    }
  ]
})

// 路由守卫，验证登录状态
Router.beforeEach((to, from, next) => {
  const store = useStore();

  if (to.meta.requiresAuth && !store.getters.getToken) {
    next('/login');
  } else {
    next();
  }
});

export default Router;
